export default function () {
  window.fbAsyncInit = function() {
    FB.init({
      appId      : '201034997190604',
      cookie     : true,
      xfbml      : true,
      version    : 'v2.1'
    });

    FB.AppEvents.logPageView()

    FB.getLoginStatus(function(response) {
      statusChangeCallback(response)
    })
  }

  function statusChangeCallback (response) {
    console.log({'from-facebook': response})
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/module/app.facebook.js